export enum RoutePath {
  MainPage = '/',
  AboutUs = '/aboutUs',
  UIDevelopment = '/uiDevelopment',
  DataManagement = '/dataManagement',
  IndustryNews = '/industryNews',
  ContactUs = '/contactUs',
  PrivacyAndResponsibility = '/privacyAndResponsibility',
}
